import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  Label,
  Form,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import axios from "axios"
import ReactPaginate from "react-paginate"
import { ToastContainer, toast } from "react-toastify"
import { URLS } from "../../Url"
import { useHistory } from "react-router-dom"
const Agent = () => {
  const [show, setshow] = useState(false)
  const [show1, setshow1] = useState(false)
  const history = useHistory()

  const toggle = () => setshow1(!show1)

  const [form, setform] = useState({
    email: "",
    phone: "",
    name: "",
    address: "",
    promocode: "",
  })
  const [users, setusers] = useState([])
  const [form1, setform1] = useState([])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }
  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [Files, setFiles] = useState("")
  const [Files1, setFiles1] = useState("")

  const changeHandler = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }
  const changeHandler1 = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles1(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }

  const Get = () => {
    var token = datas
    axios
      .post(
        URLS.Getagent,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setusers(res.data.agents)
      })
  }

  const custsearch = e => {
    const myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
    const token = datas

    axios
      .post(
        URLS.GetagentSearch + `${e.target.value}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setusers(res.data.agents)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const Add = () => {
    var token = datas
    const bodydata = {
      name: form.name,
      phone: form.phone,
      email: form.email,
      address: form.address,
      promocode: form.promocode,
    }
    axios
      .post(URLS.Addagent, bodydata, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            setform({
              email: "",
              phone: "",
              name: "",
              address: "",
              promocode: "",
            })
            Get()
            setshow(false)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const formsubmit = e => {
    e.preventDefault()
    Add()
  }

  const Update = () => {
    var token = datas
    const bodydata = {
      name: form1.name,
      phone: form1.phone,
      email: form1.email,
      address: form1.address,
      promocode: form1.promocode,
      status: form1.status,
    }

    axios
      .post(URLS.Editagent + form1._id, bodydata, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            Get()
            setshow1(false)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const formeditsubmit = e => {
    e.preventDefault()
    Update()
  }

  const usedata = datal => {
    setshow1(true)
    setform1(datal)
  }

  useEffect(() => {
    Get()
  }, [])

  const [listPerPage] = useState(20)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = users.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(users.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      Delete(data)
    }
  }

  const Delete = datau => {
    var token = datas
    var remid = datau._id
    axios
      .post(
        URLS.Deleteagent + remid,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            Get()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var Roles = data?.rolesAndPermission[0]

  const redirectview = data => {
    sessionStorage.setItem("agentId", data._id)
    history.push("/agentview")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="Home " breadcrumbItem="Agent" />

          <Row>
            <Col>
              {show == true ? (
                <Card className="p-4">
                  <Form
                    onSubmit={e => {
                      formsubmit(e)
                    }}
                  >
                    <h5 className="mb-3">Add New Agent</h5>
                    <Row>
                      <Col md="3">
                        <Label>Promo Code</Label>
                        <span className="text-danger">*</span>
                        <Input
                          name="promocode"
                          onChange={e => {
                            handleChange(e)
                          }}
                          type="text"
                          value={form.promocode}
                          required
                          placeholder="Enter Promo Code"
                        />
                      </Col>

                      <Col md="3">
                        <Label>Name</Label>
                        <span className="text-danger">*</span>
                        <Input
                          onChange={e => {
                            handleChange(e)
                          }}
                          name="name"
                          value={form.name}
                          required
                          type="text"
                          placeholder="Enter Name"
                        />
                      </Col>
                      <Col md="3">
                        <Label>Email Id</Label>
                        <span className="text-danger">*</span>
                        <Input
                          name="email"
                          onChange={e => {
                            handleChange(e)
                          }}
                          value={form.email}
                          required
                          type="email"
                          placeholder="Enter Email"
                        />
                      </Col>
                      <Col md="3">
                        <Label>Mobile No</Label>
                        <span className="text-danger">*</span>
                        <div className="input-group mb-3">
                          <Input
                            name="phone"
                            onChange={e => {
                              handleChange(e)
                            }}
                            value={form.phone}
                            required
                            type="text"
                            minLength="10"
                            maxLength="10"
                            pattern="[0-9]+"
                            className="form-control"
                            placeholder="Enter Mobile No"
                            aria-label="Username"
                            aria-describedby="basic-addon1"
                            onKeyPress={e => {
                              const charCode = e.which ? e.which : e.keyCode
                              if (charCode < 48 || charCode > 57) {
                                e.preventDefault()
                              }
                            }}
                          />
                        </div>
                      </Col>

                      <Col md="6">
                        <div className="mb-3">
                          <Label>Address</Label>
                          <span className="text-danger">*</span>
                          <textarea
                            onChange={e => {
                              handleChange(e)
                            }}
                            type="text"
                            name="address"
                            required
                            rows={3}
                            value={form.address}
                            placeholder="Enter Address"
                            className="form-control"
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="text-end">
                      <Button type="submit" color="success m-1" outline>
                        Submit <i className="bx bx-check-circle"></i>
                      </Button>
                      <Button
                        type="button"
                        onClick={() => {
                          setshow(!show)
                        }}
                        color="danger m-1"
                        outline
                      >
                        Cancel <i className="bx bx-x-circle"></i>
                      </Button>
                    </div>
                  </Form>
                </Card>
              ) : (
                ""
              )}
              <Card>
                <CardBody>
                  <Row>
                    {Roles?.staffAdd == true || Roles?.accessAll == true ? (
                      <>
                        <Col>
                          <Button
                            onClick={() => {
                              setshow(!show)
                            }}
                            color="primary"
                          >
                            New Agent <i className="bx bx-user-plus"></i>
                          </Button>
                        </Col>{" "}
                      </>
                    ) : (
                      ""
                    )}
                    <Col>
                      <div style={{ float: "right" }}>
                        <Input
                          name="search"
                          value={form.search}
                          onChange={custsearch}
                          type="search"
                          placeholder="Search.."
                        />
                      </div>
                    </Col>
                  </Row>
                  <div className="table-rep-plugin mt-4 table-responsive">
                    <Table hover bordered responsive>
                      <thead>
                        <tr className="text-center">
                          <th>Sl.No</th>
                          <th>Promo Code</th>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Mobile No</th>
                          <th>Address</th>
                          <th>Status</th>
                          <th style={{ width: "250px" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {lists.map((data, key) => (
                          <tr key={key} className="text-center">
                            <th scope="row">
                              {(pageNumber - 1) * 20 + key + 21}
                            </th>
                            <td>{data.promocode}</td>
                            <td>{data.name}</td>
                            <td>{data.email}</td>
                            <td>{data.phone}</td>
                            <td>{data.address}</td>
                            <td>{data.status}</td>
                            <td style={{ width: "250px" }}>
                              <Button
                                onClick={() => {
                                  redirectview(data)
                                }}
                                className="m-1 btn-sm"
                                color="warning"
                              >
                                <div className="d-flex">
                                  <small className="d-flex">
                                    <i className="bx bx-show px-1"></i>
                                    View
                                  </small>
                                </div>
                              </Button>
                              {Roles?.staffEdit == true ||
                              Roles?.accessAll == true ? (
                                <>
                                  <Button
                                    onClick={() => {
                                      usedata(data)
                                    }}
                                    className="m-1 btn-sm"
                                    color="success"
                                  >
                                    <div className="d-flex">
                                      <small className="d-flex">
                                        <i className="bx bx-edit px-1"></i>
                                        Edit
                                      </small>
                                    </div>
                                  </Button>
                                </>
                              ) : (
                                ""
                              )}

                              {Roles?.staffDelete == true ||
                              Roles?.accessAll == true ? (
                                <>
                                  <Button
                                    className="m-1 btn-sm"
                                    color="danger"
                                    onClick={() => {
                                      manageDelete(data)
                                    }}
                                  >
                                    <div className="d-flex">
                                      <small className="d-flex">
                                        <i className="bx bx-trash px-1"></i>
                                        Delete
                                      </small>
                                    </div>
                                  </Button>
                                </>
                              ) : (
                                ""
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    <Col sm="12">
                      <div
                        className="d-flex mt-3 mb-1"
                        style={{ float: "right" }}
                      >
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </div>
      <Modal size="lg" isOpen={show1} toggle={toggle} centered>
        <ModalHeader toggle={toggle}>Edit Agent Details</ModalHeader>
        <ModalBody>
          <Form
            onSubmit={e => {
              formeditsubmit(e)
            }}
          >
            <Row>
              <Col md="6">
                <div className="mb-3">
                  <Label>Promo Code</Label>
                  <span className="text-danger">*</span>
                  <Input
                    name="promocode"
                    onChange={e => {
                      handleChange1(e)
                    }}
                    value={form1.promocode}
                    required
                    type="text"
                    placeholder="Enter Promo Code"
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label>Name</Label>
                  <span className="text-danger">*</span>
                  <Input
                    name="name"
                    onChange={e => {
                      handleChange1(e)
                    }}
                    value={form1.name}
                    required
                    type="text"
                    placeholder="Enter Name"
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label>Email Id</Label> <span className="text-danger">*</span>
                  <Input
                    name="email"
                    onChange={e => {
                      handleChange1(e)
                    }}
                    value={form1.email}
                    required
                    type="email"
                    placeholder="Enter Email"
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label>Mobile No</Label>
                  <span className="text-danger">*</span>
                  <div className="input-group mb-3">
                    <Input
                      name="phone"
                      onChange={e => {
                        handleChange1(e)
                      }}
                      value={form1.phone}
                      required
                      type="text"
                      minLength="10"
                      maxLength="10"
                      pattern="[0-9]+"
                      className="form-control"
                      placeholder="Enter Mobile No"
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      onKeyPress={e => {
                        const charCode = e.which ? e.which : e.keyCode
                        if (charCode < 48 || charCode > 57) {
                          e.preventDefault()
                        }
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label>Address</Label>
                  <span className="text-danger">*</span>
                  <textarea
                    onChange={e => {
                      handleChange1(e)
                    }}
                    type="text"
                    name="address"
                    required
                    rows={1}
                    value={form1.address}
                    placeholder="Enter Address"
                    className="form-control"
                  />
                </div>
              </Col>
              <Col md="6">
                <div className="mb-3">
                  <Label> Status </Label> <span className="text-danger">*</span>
                  <select
                    name="status"
                    onChange={e => {
                      handleChange1(e)
                    }}
                    value={form1.status}
                    required
                    className="form-select"
                  >
                    <option value="">Select</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div>
              </Col>
            </Row>
            <div className="text-end mt-3">
              <Button type="submit" color="success m-1" outline>
                Submit <i className="bx bx-check-circle"></i>
              </Button>
              <Button
                type="button"
                onClick={() => {
                  setshow1(!show1)
                }}
                color="danger m-1"
                outline
              >
                Cancel <i className="bx bx-x-circle"></i>
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  )
}

export default Agent
